import { NOTIFICATION_EVENT, NotificationEventName } from '@/shared/api/notifications/types';

export const NOTIFICATION_EVENT_MESSAGES: Record<NotificationEventName, string> = {
  [NOTIFICATION_EVENT.LipSyncDone]: 'Lip-sync is ready.',
};
